<div class="router-permission">
    <div class="permission-panel-container">
        <app-permission-panel [roleActive]="roleActive"></app-permission-panel>
    </div>
</div>
